<template>
  <div>
    <section-title class="mt-3" content="Script Generado" :has-line="true" />
    <div class="rounded bg-light-gray pt-2 p-3">
      <div class="d-flex rounded-lg bg-white py-3 px-3 border-color--gray-2">
        <i class="fa-solid fa-caret-right"></i>
        <span
          class="font-14 font-weight-normal col-12"
          style="overflow-wrap: break-word"
        >
          {{ value }}
        </span>
      </div>
      <div class="row d-flex justify-content-end mt-2">
        <action-button
          id="modal-btn-anadir"
          variant="outline-success"
          type="button"
          i="fas fa-copy"
          @click="copy"
          :class="isMobile ? 'col col-md-3 mx-3' : 'my-2 mx-3 float-right'"
        >
          Copiar Script
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle'
import ActionButton from 'ActionButton'
export default {
  name: 'Script',
  components: {
    SectionTitle,
    ActionButton,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.value)
    },
  },
}
</script>

<style lang="scss" scoped></style>
